var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 197,
    height: 211,
    viewBox: "0 0 197 211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2141",
    "data-name": "Group 2141",
    transform: "translate(-1522 -400)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2040",
    "data-name": "Group 2040"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2641",
    "data-name": "Rectangle 2641",
    width: 60,
    height: 105,
    transform: "translate(1522 506)",
    fill: "#e6694a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2036",
    "data-name": "Group 2036",
    transform: "translate(-3313 -2911)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2642",
    "data-name": "Rectangle 2642",
    width: 11,
    height: 11,
    transform: "translate(4847 3427)",
    fill: "#f47f62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2643",
    "data-name": "Rectangle 2643",
    width: 11,
    height: 11,
    transform: "translate(4860 3427)",
    fill: "#f47f62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2644",
    "data-name": "Rectangle 2644",
    width: 11,
    height: 11,
    transform: "translate(4873 3427)",
    fill: "#f47f62"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2038",
    "data-name": "Group 2038",
    transform: "translate(-3313 -2898)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2642-2",
    "data-name": "Rectangle 2642",
    width: 11,
    height: 11,
    transform: "translate(4847 3427)",
    fill: "#f47f62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2643-2",
    "data-name": "Rectangle 2643",
    width: 11,
    height: 11,
    transform: "translate(4860 3427)",
    fill: "#f47f62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2644-2",
    "data-name": "Rectangle 2644",
    width: 11,
    height: 11,
    transform: "translate(4873 3427)",
    fill: "#f47f62"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2039",
    "data-name": "Group 2039",
    transform: "translate(-3313 -2885)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2642-3",
    "data-name": "Rectangle 2642",
    width: 11,
    height: 11,
    transform: "translate(4847 3427)",
    fill: "#f47f62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2644-3",
    "data-name": "Rectangle 2644",
    width: 11,
    height: 11,
    transform: "translate(4873 3427)",
    fill: "#f47f62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2645",
    "data-name": "Rectangle 2645",
    width: 11,
    height: 11,
    transform: "translate(4860 3427)",
    fill: "#f47f62"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2646",
    "data-name": "Rectangle 2646",
    width: 7,
    height: 21,
    transform: "translate(1549 590)",
    fill: "#113689"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2045",
    "data-name": "Group 2045",
    transform: "translate(5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2641-2",
    "data-name": "Rectangle 2641",
    width: 60,
    height: 143,
    transform: "translate(1588 468)",
    fill: "#e6694a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2646-2",
    "data-name": "Rectangle 2646",
    width: 7,
    height: 21,
    transform: "translate(1615 590)",
    fill: "#113689"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2043",
    "data-name": "Group 2043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2036-2",
    "data-name": "Group 2036",
    transform: "translate(-3247 -2949)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2642-4",
    "data-name": "Rectangle 2642",
    width: 11,
    height: 11,
    transform: "translate(4847 3427)",
    fill: "#f47f62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2643-3",
    "data-name": "Rectangle 2643",
    width: 11,
    height: 11,
    transform: "translate(4860 3427)",
    fill: "#f47f62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2644-4",
    "data-name": "Rectangle 2644",
    width: 11,
    height: 11,
    transform: "translate(4873 3427)",
    fill: "#f47f62"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2038-2",
    "data-name": "Group 2038",
    transform: "translate(-3247 -2936)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2642-5",
    "data-name": "Rectangle 2642",
    width: 11,
    height: 11,
    transform: "translate(4847 3427)",
    fill: "#f47f62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2643-4",
    "data-name": "Rectangle 2643",
    width: 11,
    height: 11,
    transform: "translate(4860 3427)",
    fill: "#f47f62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2644-5",
    "data-name": "Rectangle 2644",
    width: 11,
    height: 11,
    transform: "translate(4873 3427)",
    fill: "#f47f62"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2039-2",
    "data-name": "Group 2039",
    transform: "translate(-3247 -2923)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2642-6",
    "data-name": "Rectangle 2642",
    width: 11,
    height: 11,
    transform: "translate(4847 3427)",
    fill: "#f47f62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2644-6",
    "data-name": "Rectangle 2644",
    width: 11,
    height: 11,
    transform: "translate(4873 3427)",
    fill: "#f47f62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2645-2",
    "data-name": "Rectangle 2645",
    width: 11,
    height: 11,
    transform: "translate(4860 3427)",
    fill: "#f47f62"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2041",
    "data-name": "Group 2041",
    transform: "translate(-3247 -2910)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2642-7",
    "data-name": "Rectangle 2642",
    width: 11,
    height: 11,
    transform: "translate(4847 3427)",
    fill: "#f47f62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2644-7",
    "data-name": "Rectangle 2644",
    width: 11,
    height: 11,
    transform: "translate(4873 3427)",
    fill: "#f47f62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2645-3",
    "data-name": "Rectangle 2645",
    width: 11,
    height: 11,
    transform: "translate(4860 3427)",
    fill: "#f47f62"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2042",
    "data-name": "Group 2042",
    transform: "translate(-3247 -2897)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2642-8",
    "data-name": "Rectangle 2642",
    width: 11,
    height: 11,
    transform: "translate(4847 3427)",
    fill: "#f47f62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2644-8",
    "data-name": "Rectangle 2644",
    width: 11,
    height: 11,
    transform: "translate(4873 3427)",
    fill: "#f47f62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2645-4",
    "data-name": "Rectangle 2645",
    width: 11,
    height: 11,
    transform: "translate(4860 3427)",
    fill: "#f47f62"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2647",
    "data-name": "Rectangle 2647",
    width: 60,
    height: 211,
    transform: "translate(1659 400)",
    fill: "#e6694a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSGraph);
export default __webpack_public_path__ + "static/media/s-graph.da613b398f11b28f774c2add9a412e03.svg";
export { ForwardRef as ReactComponent };